import { render, staticRenderFns } from "./SystemSelect.vue?vue&type=template&id=4ed0d306&"
import script from "./SystemSelect.vue?vue&type=script&lang=ts&"
export * from "./SystemSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports